export const APP_VERSION = '1.0.0';
export const BUILD_VERSION = '2026.07.27.1559+c958e54';
